import DcIcon from "./DcIcon.vue";

// Finally export as default
export default {
	install(Vue) {
		Vue.component("DcIcon", DcIcon);
	}
};
